import Drawer from '@components/Drawer';
import DrawerFooter from '@components/Drawer/footer';
import React from 'react';
import FilterAdvance from './components/FilterAdvance';

const FilterAdvanceDrawer = ({
  isOpen,
  onDrawerClose,
  dataFilterAdvance,
  setDataFilterAdvance,
  flagSearch,
  setFlagSearch,
  setCurrentPage = () => {}
}) => {
  return (
    <Drawer
      title="Tìm kiếm nâng cao"
      open={isOpen}
      onClose={onDrawerClose}
      width="320px"
      footer={
        <DrawerFooter
          onSaveClick={() => {
            setCurrentPage(1);
            setFlagSearch(!flagSearch);
            onDrawerClose();
          }}
          onCancel={onDrawerClose}
        />
      }>
      <FilterAdvance
        dataFilter={dataFilterAdvance}
        onChange={setDataFilterAdvance}
        flagSearch={flagSearch}
        setFlagSearch={setFlagSearch}
      />
    </Drawer>
  );
};

export default FilterAdvanceDrawer;
